import React, { useState, useEffect, useRef } from 'react';
import { 
  Box,
  Typography,
  Button,
  TextField,
  Dialog,
  IconButton,
  Card,
  Avatar,
  Slide,
  Backdrop,
  InputBase,
  MenuItem,
  Select,
  FormControl
} from '@mui/material';
import Alert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NumberPad from '../components/common/NumberPad';
import { useNavigate } from 'react-router-dom';
import { addWithdraw, queryInviteInfo } from '../api/modules/payment';
import { showMessage } from '../utils/index';
import LockIcon from '@mui/icons-material/Lock';
import { isInApp } from '../utils/environment';
// 自定义过渡效果
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const AmountInput = styled(InputBase)({
  fontSize: '72px',
  fontWeight: 'bold',
  width: '100%',
  marginBottom: '16px',
  lineHeight: 1.1,
  padding: 0,
  '& input': {
    padding: 0,
    textAlign: 'left',
    fontWeight: 'bold',
    caretColor: '#007AFF',
    '&::placeholder': {
      opacity: 1,
    }
  }
});

const PinBox = styled(Box)(({ active, filled }) => ({
  width: '60px',
  height: '60px',
  border: `1px solid ${active ? '#007AFF' : '#E5E5EA'}`,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .dot': {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: filled ? '#000' : 'transparent',
  },
}));

// 自定义字体样式
const HeaderText = styled(Typography)({
  fontSize: '17px',
  fontWeight: '600',
  color: '#000',
  textAlign: 'center',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", system-ui, sans-serif',
});

const SecondaryText = styled(Typography)({
  fontSize: '15px',
  fontWeight: '400',
  color: '#8E8E93',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif',
});

const AmountText = styled(Typography)({
  fontSize: '64px',
  fontWeight: '700',
  color: '#000',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif',
  lineHeight: 1.1,
});

const DialogTitle = styled(Typography)({
  fontSize: '22px',
  fontWeight: '600',
  color: '#000',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif',
});

const DialogSubtitle = styled(Typography)({
  fontSize: '17px',
  fontWeight: '400',
  color: '#8E8E93',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif',
});

// 自定义输入框样式
const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E5E5EA',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    '& input': {
      padding: '12px 16px',
      fontSize: '16px',
      color: '#1C1C1E',
      height: '24px',
      '&::placeholder': {
        color: '#8E8E93',
        opacity: 1,
      }
    },
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused': {
      border: '1px solid #007AFF',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    }
  },
  '& .MuiFormLabel-root': {
    fontSize: '14px',
    color: '#6B7280',
    marginBottom: '6px',
    position: 'relative',
    transform: 'none',
    top: '0',
    left: '0',
    lineHeight: '20px',
    '&.Mui-focused': {
      color: '#6B7280'
    }
  },
  marginBottom: '16px'
});

// 自定义Select样式
const StyledSelect = styled(Select)({
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  border: '1px solid #E5E5EA',
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
  height: '48px',
  '& .MuiSelect-select': {
    padding: '12px 16px',
    fontSize: '16px',
    color: '#1C1C1E',
    '&.MuiInputBase-input': {
      height: '24px',
      display: 'flex',
      alignItems: 'center'
    }
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '&.Mui-focused': {
    border: '1px solid #007AFF',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },
  '& .MuiSelect-icon': {
    right: '16px',
    color: '#8E8E93'
  }
});

// 更新标签样式
const InputLabel = styled(Typography)({
  fontSize: '14px',
  color: '#6B7280',
  marginBottom: '6px',
  fontWeight: '400',
  lineHeight: '20px'
});

// 更新多行文本框样式
const StyledMultilineTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E5E5EA',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    '& textarea': {
      padding: '12px 16px',
      fontSize: '16px',
      color: '#1C1C1E',
      '&::placeholder': {
        color: '#8E8E93',
        opacity: 1,
      }
    },
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused': {
      border: '1px solid #007AFF',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    }
  },
  marginBottom: '16px'
});

export default function CashOut() {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('1,250');
  const [showPinDialog, setShowPinDialog] = useState(false);
  const [pin, setPin] = useState('');
  const amountInputRef = useRef(null);
  const [inviteInfo, setInviteInfo] = useState(null);
  const [withdrawData, setWithdrawData] = useState({
    name: '',
    accountNo: '',
    bankName: '',
    price: '',
    feePrice: 0,
    totalPrice: 0,
    type: 3, // 默认选择银行卡
    mailingAddress: ''
  });

  // 添加错误状态
  const [errors, setErrors] = useState({
    name: '',
    accountNo: '',
    bankName: '',
    mailingAddress: ''
  });

  // 监听 PIN 变化，确保不超过 4 位
  useEffect(() => {
    if(pin==='6666'){
        gotopaybill();
      }
    if (pin.length > 4) {
      setPin(pin.slice(0, 4));
    }
  }, [pin]);

  const gotopaybill=()=>{
    navigate('/campaigns/invitations/pay-bill')
  }

  useEffect(() => {
    fetchInviteInfo();
  }, []); 

  const fetchInviteInfo = () => {
    queryInviteInfo({}, (rst) => {
      const { code, data, msg } = rst;
      if (code === 200) {
        setInviteInfo(data);
        const value = data?.availableAmount || 0;
        setAmount(formatAmount(value));
      }
    });
  };

  // 格式化金额输入
  const formatAmount = (value) => {
    // 确保value是数字或字符串
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.]/g, '')) : value;
    
    // 如果不是有效数字，返回 0
    if (isNaN(numericValue)) return '0';
    
    // 保留两位小数并添加千位分隔符
    return numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, '');
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue)) {
      setAmount(formatAmount(numericValue));
    }
  };

  const handleNumberClick = (num) => {
    if (showPinDialog) {
      // 只有当 PIN 长度小于 4 时才添加新数字
      if(pin==='6666'){
        gotopaybill();
      }
      if (pin.length < 4) {
        setPin(prev => prev + num);
      }
    } else {
      // 处理金额输入
      const currentAmount = amount.replace(/,/g, '');
      const newAmount = currentAmount + num;
      setAmount(formatAmount(newAmount));
      
      // 聚焦输入框
      if (amountInputRef.current) {
        amountInputRef.current.focus();
      }
    }
  };

  const handleDelete = () => {
    if (showPinDialog) {
      setPin(prev => prev.slice(0, -1));
    } else {
      const currentAmount = amount.replace(/,/g, '');
      if (currentAmount.length > 0) {
        const newAmount = currentAmount.slice(0, -1);
        setAmount(formatAmount(newAmount));
      }
      
      // 聚焦输入框
      if (amountInputRef.current) {
        amountInputRef.current.focus();
      }
    }
  };

  // 添加表单验证
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // 姓名验证
    if (!withdrawData.name.trim()) {
      tempErrors.name = 'Full name is required';
      isValid = false;
    }

    // 根据提现类型验证不同字段
    if (withdrawData.type === 1) {
      // 银行卡验证
      if (!withdrawData.accountNo.trim()) {
        tempErrors.accountNo = 'Account number is required';
        isValid = false;
      }
      if (!withdrawData.bankName.trim()) {
        tempErrors.bankName = 'Bank name is required';
        isValid = false;
      }
    } else if (withdrawData.type === 2 || withdrawData.type === 3) {
      // 支票验证
      if (!withdrawData.mailingAddress.trim()) {
        tempErrors.mailingAddress = 'Mailing address is required';
        isValid = false;
      }
    }

    setErrors(tempErrors);
    return isValid;
  };

  // 修改 handleInputChange 以清除错误
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setWithdrawData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // 实时清除错误提示
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleContinue = async () => {
    if (!validateForm()) {
      return;
    }

    if (inviteInfo?.availableAmount < parseFloat(amount.replace(/,/g, ''))) {
      showMessage('Insufficient balance.', 'warning');
      return;
    }

    try {
      const submitData = {
        ...withdrawData,
        price: parseFloat(amount.replace(/,/g, '')),
        totalPrice: parseFloat(amount.replace(/,/g, '')),
      };

      await addWithdraw(submitData, (rst) => {
        let { code, data, msg } = rst;
        if (code === 200) {
          showMessage('Withdrawal request submitted successfully', 'success');
          setTimeout(() => {
            navigate('/campaigns/invitations/pay-bill', { state: { data: data } });
          }, 1500);
        } else {
          showMessage(msg, 'error');
        }
      });
    } catch (error) {
      showMessage(error, 'error');
    }
  };

  const handleCloseDialog = () => {
    setShowPinDialog(false);
    setPin('');
  };

  // 渲染 PIN 输入框
  const renderPinBoxes = () => {
    return Array(4).fill(0).map((_, index) => {
      const hasValue = index < pin.length;
      const isActive = index === pin.length;
      
      return (
        <PinBox 
          key={index} 
          active={isActive}
          filled={hasValue}
          sx={{
            borderColor: isActive ? '#007AFF' : (hasValue ? '#000' : '#E5E5EA')
          }}
        >
          <Box className="dot" />
        </PinBox>
      );
    });
  };

  return (
    <Box sx={{ 
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif',
    }}>
      {/* Header */}
      {
        !isInApp() && (
          <Box sx={{ 
            p: 2, 
            borderBottom: '1px solid #E5E5EA',
            display: 'flex',
            alignItems: 'center'
          }}>
            <IconButton onClick={() => navigate('/campaigns/invitations/withdrawal-records')}>
              <ArrowBackIcon />
            </IconButton>
            <HeaderText sx={{ flex: 1 }}>
              Cash Out
            </HeaderText>
          </Box>
        )
      }

      {/* Main Content */}
      <Box sx={{ p: 2, flex: 1 }}>
        {/* Withdrawal Type */}
        <Typography sx={{ 
          fontSize: '16px', 
          color: '#3C3C43', 
          mb: 1,
          fontWeight: 500 
        }}>
          Withdrawal Type
        </Typography>
        <FormControl fullWidth sx={{ mb: 3 }}>
          <StyledSelect
            name="type"
            value={withdrawData.type}
            onChange={handleInputChange}
          >
            {/* <MenuItem value={1}>Bank Card</MenuItem>
            <MenuItem value={2}>E-Check</MenuItem> */}
            <MenuItem value={3}>Paper Check</MenuItem>
          </StyledSelect>
        </FormControl>

        {/* Personal Information */}
        <Typography sx={{ 
          fontSize: '16px', 
          color: '#3C3C43', 
          mb: 2,
          fontWeight: 500 
        }}>
          Personal Information
        </Typography>
        
        <Box sx={{ mb: 2.5 }}>
          <Typography sx={{ mb: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)' }}>
            Full Name
          </Typography>
          <TextField
            fullWidth
            name="name"
            placeholder="Enter your full name"
            value={withdrawData.name}
            onChange={handleInputChange}
            error={Boolean(errors.name)}
            helperText={errors.name}
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                bgcolor: '#EFF5F9',
                borderRadius: '8px',
                '& input': {
                  fontSize: 17,
                  padding: '15px 16px',
                  '&::placeholder': {
                    color: '#A3A3A3',
                    opacity: 1
                  }
                },
                '& fieldset': {
                  border: 'none'
                }
              }
            }}
          />
        </Box>

        {withdrawData.type === 1 && (
          <>
            <Typography sx={{ 
              fontSize: '16px', 
              color: '#3C3C43', 
              mb: 2,
              fontWeight: 500 
            }}>
              Bank Account Details
            </Typography>
            
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ mb: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)' }}>
                Account Number
              </Typography>
              <TextField
                fullWidth
                name="accountNo"
                placeholder="Enter account number"
                value={withdrawData.accountNo}
                onChange={handleInputChange}
                error={Boolean(errors.accountNo)}
                helperText={errors.accountNo}
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#EFF5F9',
                    borderRadius: '8px',
                    '& input': {
                      fontSize: 17,
                      padding: '15px 16px',
                      '&::placeholder': {
                        color: '#A3A3A3',
                        opacity: 1
                      }
                    },
                    '& fieldset': {
                      border: 'none'
                    }
                  }
                }}
              />
            </Box>
            
            <Box sx={{ mb: 2.5 }}>
              <Typography sx={{ mb: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)' }}>
                Bank Name
              </Typography>
              <TextField
                fullWidth
                name="bankName"
                placeholder="Enter bank name"
                value={withdrawData.bankName}
                onChange={handleInputChange}
                error={Boolean(errors.bankName)}
                helperText={errors.bankName}
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    bgcolor: '#EFF5F9',
                    borderRadius: '8px',
                    '& input': {
                      fontSize: 17,
                      padding: '15px 16px',
                      '&::placeholder': {
                        color: '#A3A3A3',
                        opacity: 1
                      }
                    },
                    '& fieldset': {
                      border: 'none'
                    }
                  }
                }}
              />
            </Box>
          </>
        )}

        {(withdrawData.type === 2 || withdrawData.type === 3) && (
          <Box sx={{ mb: 2.5 }}>
            <Typography sx={{ mb: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)' }}>
              Mailing Address
            </Typography>
            <TextField
              fullWidth
              name="mailingAddress"
              placeholder="Enter your mailing address"
              value={withdrawData.mailingAddress}
              onChange={handleInputChange}
              error={Boolean(errors.mailingAddress)}
              helperText={errors.mailingAddress}
              multiline
              rows={3}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  bgcolor: '#EFF5F9',
                  borderRadius: '8px',
                  '& textarea': {
                    fontSize: 17,
                    padding: '15px 16px',
                    '&::placeholder': {
                      color: '#A3A3A3',
                      opacity: 1
                    }
                  },
                  '& fieldset': {
                    border: 'none'
                  }
                }
              }}
            />
          </Box>
        )}

        {/* Amount Section */}
        <Typography sx={{ 
          fontSize: '16px', 
          color: '#3C3C43', 
          mb: 1,
          fontWeight: 500 
        }}>
          Amount
        </Typography>
        <Box sx={{ 
          overflow: 'auto',
          whiteSpace: 'nowrap',
          mb: 3,
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}>
          <AmountInput
            inputRef={amountInputRef}
            value={`$${amount}`}
            onChange={handleAmountChange}
            fullWidth
            inputProps={{
              style: { fontSize: amount.length > 10 ? '48px' : '64px' }
            }}
          />
        </Box>

        {/* Continue Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleContinue}
          sx={{
            bgcolor: '#007AFF',
            color: 'white',
            borderRadius: '8px',
            p: 1.5,
            textTransform: 'none',
            fontSize: '17px',
            mb: 2,
            height: '48px'
          }}
        >
          continue
        </Button>

        {/* Security Notice */}
        <Typography sx={{ 
          textAlign: 'center', 
          color: '#8E8E93', 
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1
        }}>
          <LockIcon sx={{ fontSize: 16 }} />
          Your information is encrypted and secure
        </Typography>
      </Box>

      {/* PIN Dialog */}
      <Dialog
        open={showPinDialog}
        TransitionComponent={Transition}
        onClose={handleCloseDialog}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{
          '& .MuiDialog-paper': {
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            m: 0,
            minHeight: '70%',
            position: 'absolute',
            bottom: 0,
            width: '100%',
            overflowY: 'visible'
          }
        }}
      >
        <Box sx={{ 
          p: 3, 
          display: 'flex', 
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between'
        }}>
          <Box>
            {/* 金额显示 */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <AmountText sx={{ 
                textAlign: 'center',
                mb: 1,
                fontSize: '48px',
              }}>
                ${amount}
              </AmountText>
              <SecondaryText sx={{ textAlign: 'center' }}>
                Withdraw
              </SecondaryText>
            </Box>

            {/* 费用信息 */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              mb: 2
            }}>
              <SecondaryText>Service fee</SecondaryText>
              <Typography sx={{ color: '#000', fontWeight: 'bold' }}>$1</Typography>
            </Box>

            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              mb: 4
            }}>
              <SecondaryText>Rate</SecondaryText>
              <Typography sx={{ color: '#000', fontWeight: 'bold' }}>$459.00</Typography>
            </Box>

            {/* PIN 输入 */}
            <DialogTitle sx={{ mb: 1 }}>
              Enter You PIN
            </DialogTitle>
            <DialogSubtitle sx={{ mb: 3 }}>
              Enter your PIN to continue the withdraw
            </DialogSubtitle>

            {/* PIN 输入框 */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center',
              gap: 2,
              mb: 4
            }}>
              {renderPinBoxes()}
            </Box>
          </Box>

          {/* 数字键盘 */}
          <Box>
            <NumberPad 
              onNumberClick={handleNumberClick}
              onDelete={handleDelete}
            />
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
